import { createAction, props } from '@ngrx/store';
import { BlogModel } from '../model/blog.model';

export const BLOG = '[Blog Page] Blog';
export const BLOG_SUCCESS = '[Blog Page] Blog Success';
export const BLOG_FAILURE = '[Blog Page] Blog Failure';

export const BLOG_LOAD_MORE = '[Blog Page] Blog load more';
export const BLOG_LOAD_MORE_SUCCESS = '[Blog Page] Blog load more Success';
export const BLOG_LOAD_MORE_FAILURE = '[Blog Page] Blog load more Failure';

export const blog = createAction(
    BLOG
)

export const blogSuccess = createAction(
    BLOG_SUCCESS,
    props<{blog: BlogModel}>()
)

export const blogFailure = createAction(
    BLOG_FAILURE,
    props<{error: string}>()
)

export const blogLoadMore = createAction(
    BLOG_LOAD_MORE,
    props<{start: Number}>()
)

export const blogLoadMoreSuccess = createAction(
    BLOG_LOAD_MORE_SUCCESS,
    props<{blog: BlogModel}>()
)

export const blogLoadMoreFailure = createAction(
    BLOG_LOAD_MORE_FAILURE,
    props<{error: string}>()
)
